import React, { FC, useState } from 'react';
import { ScrollView, Text, View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import i18n from 'i18n-js';
import ColorWrapper from '@styles/colors';
import Selectors from '@styles/selectors';
import { AttachEntitiesListProps, LoadingState } from './types';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

const AttachEntitiesList: FC<AttachEntitiesListProps> = ({
  imageDocumentLinks,
  imageDocumentReferences,
  onAttachItemPress,
  style,
  C,
  scale = initialScale,
  font = initialFont,
}) => {
  const [loadingState, setLoadingState] = useState<LoadingState>({ id: null, loading: false });

  return (
    <View
      style={[
        {
          paddingHorizontal: scale(9),
          paddingBottom: scale(9),
          flexDirection: 'row',
          maxHeight: scale(100),
        },
        style,
      ]}
    >
      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ flexDirection: 'row' }}>
        <View style={{ alignSelf: 'flex-start', flexShrink: 0, marginTop: scale(6) }}>
          <Text
            style={[
              font['Subhead 2'],
              {
                color: C('Label/Light/Unselected'),
                marginRight: scale(10),
                flex: 0,
              },
            ]}
          >
            {i18n.t('Click to attach to')}:
          </Text>
        </View>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: scale(9),
          }}
        >
          {imageDocumentReferences.map((r) => {
            const isAttached = imageDocumentLinks?.some((l) => l.scopeId === r.scopeId && l.scopeReferenceId === r.scopeReferenceId);
            const loading = loadingState.id === r.scopeReferenceId && loadingState.loading;

            return (
              <Selectors
                key={`${r.scopeId}-${r.scopeReferenceId}`}
                testID={
                  isAttached
                    ? TEST_IDS.imageUploadPopup.preselectedTag(r.scopeId, r.scopeReferenceId)
                    : TEST_IDS.imageUploadPopup.tag(r.scopeId, r.scopeReferenceId)
                }
                disabled={loading}
                scale={scale}
                font={font}
                selected={isAttached}
                variant="OUTLINE"
                text={`${i18n.t(r.scopeName)} ${r.scopeReferenceName}`}
                onPress={() =>
                  onAttachItemPress({
                    link: {
                      scopeId: r.scopeId,
                      scopeReferenceId: r.scopeReferenceId,
                      scopeReferenceName: r.scopeReferenceName,
                      isSelected: isAttached,
                    },
                    setLoadingState,
                  })
                }
                loading={loading}
                icon={{
                  name: isAttached ? 'attached' : 'attach',
                  width: scale(24),
                  height: scale(24),
                }}
              />
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
};

export default ColorWrapper(AttachEntitiesList);
